import { createStore, applyMiddleware, Store, AnyAction } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import { AppState } from './rootReducer';

import rootReducer from './rootReducer';
import { rootSaga } from './rootSaga';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['authReducer', 'languagesReducer', 'taskTypesReducer'],
};

export const configureStore = (): Promise<Store<unknown, AnyAction>> => {
    return new Promise((resolve, reject) => {
        try {
            const persistedReducer = persistReducer(persistConfig, rootReducer);

            const sagaMiddleware = createSagaMiddleware();

            const middlewares =
                process.env.REACT_APP_ENV !== 'PRODUCTION'
                    ? applyMiddleware(sagaMiddleware, logger)
                    : applyMiddleware(sagaMiddleware);

            const store: Store<AppState> = createStore(persistedReducer, middlewares);

            sagaMiddleware.run(rootSaga);

            persistStore(store, null, () => resolve(store));
        } catch (e) {
            reject(e);
        }
    });
};
